import { getFileProviderAuthHeaderValue } from 'owa-fileprovider-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';

// The space here is important.
const BEARER_PREFIX = 'Bearer ';

export async function getDefaultSPPageContext(webUrl: string) {
    const dummySsid = '00000000-0000-0000-0000-000000000000';
    let token;
    try {
        const fullToken = await getFileProviderAuthHeaderValue(
            AttachmentDataProviderType.OneDrivePro,
            false,
            webUrl
        );
        token = fullToken.split(BEARER_PREFIX)[1];
    } catch {
        // Do nothing. The dialog will open with a 'something went wrong' which is true.
        // If the auth token isn't available at all we wouldn't have made it this far.
    }
    return {
        authToken: token,
        webAbsoluteUrl: webUrl,
        webTemplate: '21',
        currentUICultureName: 'en-US',
        env: 'edog',
        farmLabel: undefined,
        siteSubscriptionId: dummySsid,
        listUrl: undefined,
        layoutsUrl: '_layouts/15',
        serverRequestPath: '',
        siteAbsoluteUrl: '',
        siteClientTag: '',
        webLogoUrl: '',
        userEmail: '',
        webServerRelativeUrl: '',
        webTitle: '',
        hasManageWebPermissions: true,
        isSiteAdmin: true,
        systemUserKey: '',
        userDisplayName: '',
        userId: 0,
        userLoginName: '',
        pageItemId: 0,
        preferUserTimeZone: true,
        isAppWeb: true,
    };
}
